import { render } from "./SampleDefinitionComponent.vue?vue&type=template&id=9936dc2a&scoped=true"
import script from "./SampleDefinitionComponent.vue?vue&type=script&lang=js"
export * from "./SampleDefinitionComponent.vue?vue&type=script&lang=js"

import "./SampleDefinitionComponent.vue?vue&type=style&index=0&id=9936dc2a&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Pablo Sastre\\OneDrive\\Escritorio\\BAIPManagerTestv2\\BaipMarket.Dashboard\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9936dc2a"]])

export default __exports__